import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { TransactionHistory } from '../../models/transaction-history.interface';
import { ApiEndpoints } from 'src/config/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class TransactionHistoryService {

 // private apiUrl = 'https://ib-wallet-dev-api.azurewebsites.net/api/DigitalWalletAPI/dwgettransactionhistory';
 private apiUrl = ApiEndpoints.transactionHistory;
  constructor(private http: HttpClient) {}

// In transaction-history.service.ts
// fetchTransactionHistory(walletID: string, walletRole: string, transactionType: string = 'all'): Observable<TransactionHistory> {
//   // Construct the request body according to the API's expected format
//   let sessionID=sessionStorage.getItem("SessionID");
//   const requestBody = { walletID, walletRole, transactionType,sessionID };
//   let wallettoken=sessionStorage.getItem("walletheaders");
//     let httpOptions = {
//       headers: new HttpHeaders({
//         "Access-Control-Allow-Methods": "POST, GET",
//         'Content-Type': 'application/json',
//         "Authorization": "bearer " + wallettoken
//       }),
//     };
//   return this.http.post<TransactionHistory>(this.apiUrl, requestBody,httpOptions);
// }

// transaction-history.service.ts

fetchTransactionHistory(walletID: string, walletRole: string, transactionType: string = 'all'): Observable<TransactionHistory> {
  // 1. Get the Token
  const token = sessionStorage.getItem("walletheaders");

  // 🔎 DEBUG: Check if we actually have a token
  console.log(`[TransactionHistory] Token check: ${token ? '✅ Token Found' : '❌ Token Missing'}`);

  // 🛡️ SECURITY GUARD: 
  // If the token is missing, STOP HERE. Do not call the API.
  // This prevents the server from redirecting us to the Session Validation URL.
  if (!token || token === 'undefined' || token === 'null') {
    console.warn('⛔ TransactionHistory blocked: No valid token in storage.');
    return new Observable(observer => {
      observer.complete(); // Return nothing, successfully.
    });
  }

  // 2. Prepare Request (Only runs if token exists)
  let sessionID = sessionStorage.getItem("SessionID");
  const requestBody = { walletID, walletRole, transactionType, sessionID };
  
  let httpOptions = {
    headers: new HttpHeaders({
      "Access-Control-Allow-Methods": "POST, GET",
      'Content-Type': 'application/json',
      "Authorization": "bearer " + token
    }),
  };

  return this.http.post<TransactionHistory>(this.apiUrl, requestBody, httpOptions);
}


}
